/* eslint-disable */
/** index -> 任务的序号 */
/** scene -> 当前任务的实例 */
/** taId -> 当前任务的id */
/** scene.assemblyList -> 当前任务下的场景列表 */
/** editData -> 全部添加的场景列表 */
/** singleScene -> 任务下每个单个场景的实例 */
export function taskButton(index, scene, taId, HallId) {
  // console.log(index)
  // console.log(scene)
  // console.log(scene.assemblyList)
  const promise = new Promise(function (resolve, reject) {
    let editData;
    console.log(scene);
    console.log(scene.assemblyList);
    editData = scene.assemblyList.map((res, index) => {
      const singleScene = scene.$refs[`taskIndex${index}`][0]; // 备注见7行
      let departmentName = "";
      if (res.name == "METTING") {
        departmentName = "会议室";
      }
      if (res.name == "SURVEY") {
        departmentName = "现场调研";
      }
      // const departmentName = res.
      console.log(singleScene);
      return {
        cdId: HallId,
        id: res.info?.id ? res.info?.id : "",
        departmentName: res.info?.departmentName || departmentName,
        // logicNum: singleScene.form.logic !== "" ? singleScene.form.logic : "",
        logicNum: singleScene.form && singleScene.form.logic !== "" ? singleScene.form.logic : "",
        functionName: singleScene.fun_office ? singleScene.fun_office : "",
        scene: res.name,
        taId: taId,
        taskScenatioSequenceNumber: index,
      };
    });
    /** 开始做数据检测 */
    function find(value) {
      return value.content === "";
    }
    console.log(editData);
    let v = true; /** 数据检测 是否全部填写 true为检测通过 */
    editData.forEach((element) => {
      if (element.departmentName === "领导办公室" && element.scene === "LEADERSHIPOFFICE") {
        if (JSON.parse(element.functionName).find(find)) {
          v = false;
        }
      } else if (element.departmentName === "我的办公室" && element.scene === "MYOFFICE") {
        if (!element.functionName) {
          v = false;
        }
      } else if (element.departmentName === "民意调查中心" && element.scene === "POLLINGCENTER") {
        // if (element.functionName.indexOf("\"\"") !== -1) {
        /** logic":"" 原因 判断先去掉 */
        /** 判断有无空字符串 */
        // v = false
        // }
      } else {
        if (!element.departmentName) {
          v = false;
        }
      }
    });
    console.log("taskButton", v);
    if (v) {
      resolve(editData);
    } else {
      reject();
    }
  });
  return promise;
}
